import { useState } from 'react';
import {
  Box,
  Button,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  Alert,
} from '@mui/material';
import PhoneAndroidRoundedIcon from '@mui/icons-material/PhoneAndroidRounded';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import { authApi } from '../../../services/api/authApi';
import PasswordField from '../PasswordField';
import {
  AuthDivider,
  authHintSx,
  authInputSx,
  authLabelSx,
  authIconSx,
  authLinkBtnSx,
  authOutlineBtnSx,
  authPrimaryBtnSx,
} from '../authFormTheme';

function LoginScreen({ onGoRegister, onGoForgotPassword, onLoginSuccess }) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError('');
    setLoading(true);
    try {
      const fullPhone = phone.startsWith('+') ? phone : `+91${phone.replace(/\D/g, '')}`;
      const result = await authApi.login({ phone: fullPhone, password });
      authApi.saveSession(result);
      onLoginSuccess(result.user);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack spacing={2.5}>
      {error ? <Alert severity="error" sx={{ mb: 0.5 }}>{error}</Alert> : null}

      <Typography sx={authHintSx}>
        Log in with your mobile number
      </Typography>

      <Box>
        <Typography sx={authLabelSx}>
          <PhoneAndroidRoundedIcon sx={authIconSx} fontSize="small" />
          Phone number
        </Typography>
        <TextField
          size="small"
          fullWidth
          placeholder="10-digit mobile number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          inputProps={{ inputMode: 'numeric' }}
          sx={authInputSx}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ color: 'rgba(17,24,39,0.7)', fontWeight: 800 }}>
                +91
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box>
        <Typography sx={authLabelSx}>
          <LockRoundedIcon sx={authIconSx} fontSize="small" />
          Password
        </Typography>
        <PasswordField
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          showPassword={showPassword}
          onTogglePassword={() => setShowPassword((v) => !v)}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: -0.5 }}>
        <Button
          variant="text"
          onClick={onGoForgotPassword}
          sx={{
            ...authLinkBtnSx,
            py: 0.5,
            px: 1,
          }}
        >
          Forgot password?
        </Button>
      </Box>

      <Button
        variant="contained"
        size="large"
        disabled={loading}
        onClick={handleLogin}
        sx={authPrimaryBtnSx}
      >
        {loading ? 'Logging in…' : 'Log in'}
      </Button>

      <AuthDivider>New to Eleven Games?</AuthDivider>

      <Button
        variant="outlined"
        size="large"
        onClick={onGoRegister}
        sx={authOutlineBtnSx}
      >
        Create account
      </Button>
    </Stack>
  );
}

export default LoginScreen;
